import React, {useEffect, useState} from 'react';
import '../App.css';
function Boxcliente (props){
    const [titulo, setTitulo] = useState();
    const [contenido, setContenido] = useState();
    const [pie, setPie] = useState();
    const [signo, setSigno] = useState();

    useEffect(() => {       
        setTitulo(props.titulo)
        setContenido(props.contenido)
        setPie(props.pie)
        setSigno(props.signo)
    });

    return (
    <div className="w-full bg-white rounded-lg shadow-lg p-6">
        <div className="flex flex-col items-center">
            {/* Cifra */}
            <div className="text-3xl font-bold text-green-600">
                {signo}{contenido}
            </div>
            {/* Leyenda */}
            <div className="text-sm text-gray-500 mt-2">
                {titulo} 
            </div>
            {/* Sub leyenda */}
            <div className="text-xs text-gray-400 mt-1">
                {pie}
            </div>
        </div>
    </div> 
    )
}
export default Boxcliente